import { RefObject } from 'react';

const focusInput = (
  containerRef: RefObject<HTMLElement | null>,
  inputSelector: string,
  maxAttempts = 20
) => {
  let attempts = 0;

  const tryFocus = () => {
    const input = containerRef.current?.querySelector<HTMLElement>(
      inputSelector
    );

    if (
      input &&
      typeof input.focus === 'function' &&
      !('disabled' in input && (input as HTMLInputElement).disabled)
    ) {
      input.focus();
      return;
    }

    if (attempts < maxAttempts) {
      attempts += 1;
      globalThis.requestAnimationFrame(tryFocus);
    }
  };

  globalThis.requestAnimationFrame(tryFocus);
};

export default focusInput;
